import React from 'react'
import { motion } from 'framer-motion';
import mainImg from './../../assets/contact/businessman-touching-icon-mobile-phone-mail-telephone-address 1.png'
import { CiClock2, CiMail } from 'react-icons/ci';


import sponser_1 from './../../assets/home/sponser_1.jpg'
import sponser_2 from './../../assets/home/sponser_2.jpg'
import sponser_3 from './../../assets/home/sponser_3.jpg'
import sponser_4 from './../../assets/home/sponser_4.jpg'

import studio_green_logo from './../../assets/home/Logo-studio-green.svg'
import norto_logo from './../../assets/home/Logo-Norto.svg'
import out_of_the_stand_logo from './../../assets/home/Logo-Out Of The Sand Box.svg'
import points_one_logo from './../../assets/home/Logo-points-one.svg'
import Accordion from '../Accordion/Accordion.jsx';
import { PiPhoneThin } from 'react-icons/pi';
import { Link } from 'react-router-dom';
import faq_img from "./../../assets/contact/Photo.png"

const Contact = () => {
    const accordionItems = [
        {
            title: "Question 1",
            content: "Leverage agile frameworks to provide a robust synopsis for strategy foster collaborative thinking to further the overall value proposition. Organically grow the holistic world view of disruptive.",
        },
        {
            title: "Question 2",
            content: "Leverage agile frameworks to provide a robust synopsis for strategy foster collaborative thinking to further the overall value proposition. Organically grow the holistic world view of disruptive.",
        },
        {
            title: "Question 3",
            content: "Leverage agile frameworks to provide a robust synopsis for strategy foster collaborative thinking to further the overall value proposition. Organically grow the holistic world view of disruptive.",
        },
        {
            title: "Question 4",
            content: "Leverage agile frameworks to provide a robust synopsis for strategy foster collaborative thinking to further the overall value proposition. Organically grow the holistic world view of disruptive.",
        },
    ];

    return (
        <div className="contact">
            <div className="section_1 min-h-[50vh] bg-cover bg-no-repeat" style={{ backgroundImage: `url("${mainImg}")` }}>
                <div className="layer bg-gradient-to-r min-h-[50vh] from-dark-navy to-transparent flex items-center justify-content ">
                    <motion.div
                        initial={{
                            x: -200,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }}
                        className="what-we-do col-span-3 lg:col-span-1 m-auto  w-5/6 lg:w-4/6">
                        <span className="bg-dark-navy bg-opacity-50 text-white p-1 px-2 border-l-4 border-l-cyan text-sm ">Contact</span>
                        <h2 className="text-3xl md:text-6xl text-white font-semibold my-3">Contact Us</h2>
                    </motion.div>
                </div>
            </div>
            <div className="section_2 py-16">
                <div className="w-5/6 md:w-4/6 m-auto bg-main py-10 px-8 md:px-16">
                    <div className="flex flex-col items-center justify-center">
                        <span className="bg-white text-main p-1 px-2 border-l-4 border-l-cyan text-sm ">Contact</span>
                        <h2 className="text-2xl md:text-4xl text-white font-semibold my-3">Get in touch with Us</h2>
                        <p className="text-sm text-white text-center">Leverage agile frameworks to provide a robust synopsis for strategy foster collaborative thinking to further the overall value.</p>
                    </div>
                    <div className="contact_info grid grd-cols-1 sm:grid-cols-2 md:grid-cols-3  justify-center items-center gap-4  pt-5">
                        <div className="flex flex-col items-center justify-center gap-2 my-4">
                            <div className="text-main bg-white rounded-full p-3">
                                <CiMail size={20} />
                            </div>
                            <span className='text-sm text-white font-Krub font-medium text-center'>secureTech@gmail.com</span>
                        </div>
                        <div className="flex flex-col items-center justify-center gap-2 my-4">
                            <div className="text-main bg-white rounded-full p-3">
                                <PiPhoneThin />
                            </div>
                            <span className='text-sm text-white font-Krub font-medium text-center' >(971) 112 365 489</span>
                        </div>
                        <div className="flex flex-col items-center justify-center gap-2 my-4">
                            <div className="text-main bg-white rounded-full p-3">
                                <CiClock2 />
                            </div>
                            <span className='text-sm text-white font-Krub font-medium text-center'>Mon - Sat 9.00 - 18.00
                                Sunday Closed</span>
                        </div>
                    </div>
                    <motion.form
                        initial={{
                            x: -100,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }} className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <div className="col-span-1">
                            <input type="text" className="py-4 px-5 w-full" placeholder="Your name*" />
                        </div>
                        <div className="col-span-1">
                            <input type="text" className="py-4 px-5 w-full" placeholder="Email*" />
                        </div>
                        <div className="col-span-1">
                            <input type="text" className="py-4 px-5 w-full" placeholder="Phone Number*" />
                        </div>
                        <div className="col-span-1">
                            <input type="text" className="py-4 px-5 w-full" placeholder="City*" />
                        </div>
                        <div className="col-span-1 md:col-span-2">
                            <textarea className="w-full py-4 px-5" name="Your Message" cols="30" rows="5" placeholder="Your Message" ></textarea>
                        </div>
                        <div className="col-span-1 md:col-span-2 text-center">
                            <button type="submit" className=" bg-cyan w-fit text-sm font-krub text-dark font-semibold py-3 px-6 md:py-5 md:px-11">Submit Message</button>
                        </div>
                    </motion.form>
                </div>
                <div className="sponsors w-5/6 md:w-4/6 m-auto mt-10 grid grid-cols-2 sm:grid-cols-4">
                    <motion.div
                        initial={{
                            x: -100,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }} className="col-span-1 relative border border-gray">
                        <div className="layer flex items-center justify-center p-8 h-full w-full absolute bg-gradient-to-b from-transparent to-black ">
                            <img src={studio_green_logo} alt="" />
                        </div>
                        <img src={sponser_1} alt="" />
                    </motion.div>
                    <motion.div
                        initial={{
                            x: -200,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }} className="col-span-1 relative border border-gray">
                        <div className="layer flex items-center justify-center p-8 h-full w-full absolute bg-gradient-to-b from-transparent to-black">
                            <img src={norto_logo} alt="" />
                        </div>
                        <img src={sponser_2} alt="" />
                    </motion.div>
                    <motion.div
                        initial={{
                            x: 200,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }} className="col-span-1 relative border border-gray">
                        <div className="layer flex items-center justify-center p-8 h-full w-full absolute bg-gradient-to-b from-transparent to-black">
                            <img src={points_one_logo} alt="" />
                        </div>
                        <img src={sponser_3} alt="" />
                    </motion.div>
                    <motion.div
                        initial={{
                            x: 100,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }} className="col-span-1 relative border border-gray">
                        <div className="layer flex items-center justify-center p-8 h-full w-full absolute bg-gradient-to-b from-transparent to-black">
                            <img src={out_of_the_stand_logo} alt="" />
                        </div>
                        <img src={sponser_4} alt="" />
                    </motion.div>
                </div>
            </div>
            <div className="section_4 faq bg-light py-20">
                <div className="w-5/6 m-auto grid grid-cols-1 lg:grid-cols-2 md:g gap-15 lg:gap-32">
                    <div className="text_box col-span-1">
                        <span className="bg-gray-light bg-opacity-50 text-dark p-1 px-2 border-l-4 border-l-main-light text-sm ">FAQ</span>
                        <h2 className="text-3xl md:text-3xl text-dark font-semibold my-3">Frequently Asked Questions</h2>
                        <Accordion items={accordionItems} />
                    </div>
                    <div className="bg-cover image_box col-span-1 relative min-h-[50vh]" style={{ backgroundImage: `url("${faq_img}")` }}>
                        <div className="talk bg-main  lg:w-2/3 p-10 absolute lg:-left-1/3 top-1/2 transform -translate-y-1/2 lg:translate-x-1/3">
                            <span className="bg-white text-main p-1 px-2 border-l-4 border-l-cyan text-sm ">Let's Talk</span>
                            <p className="text-lg leading-6 text-white font-medium my-2">You Need Any Help? Get Free Consultation</p>
                            <div className="phone flex items-center justify-start gap-2">
                                <div className="text-main bg-white rounded-full p-4">
                                    <PiPhoneThin />
                                </div>
                                <div className="text-white text-sm font-light">
                                    <p>Have Any Questions?</p>
                                    <span>(+971) 112 365 489</span>
                                </div>
                            </div>
                            <div className="w-full mt-7">
                                <Link to="/contact" className='bg-cyan w-fit text-sm text-dark font-krub py-4 px-6 mt-2'>Contact Us</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact